import React from "react";
import "./styles.css"; // Import your CSS file

import tifImage from "./switzerland_brain_logo.png"; // Import the .tif image
import searchIcon from "./search.png"; // Import the search icon
import currentLocationIcon from "./current-location.svg"; // Import the current location icon

import MapsComponent from "./googlemaps";

const SearchStyle = { border: "none", outline: "none", flex: 1 };

export default function Home() {
  const appStyle = {
    backgroundColor: "#10314d",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: "white"
  };

  const imageStyle = {
    maxWidth: "100%",
    maxHeight: "100%"
  };

  const searchBoxStyle = {
    backgroundColor: "white",
    borderRadius: "15px", // Adjust the radius to control roundness
    padding: "10px",
    marginTop: "20px", // Adjust the margin to control the distance from the image
    display: "flex",
    alignItems: "center"
  };

  const searchButtonStyle = {
    background: "none",
    border: "none",
    cursor: "pointer",
    marginLeft: "10px", // Adjust the margin to control the distance from the input
    display: "flex",
    alignItems: "center"
  };

  const iconStyle = {
    width: "20px", // Adjust the icon size as needed
    height: "20px",
    marginRight: "5px" // Adjust the space between the icon and text
  };

  const labelTextStyle = {
    color: "gray" // Set the text color to gray
  };

  return (
    <div style={appStyle} className="App">
      <h1>Hello CodeSandbox</h1>
      <h2>Start editing to see some magic happen!</h2>
      <img src={tifImage} alt="Your .tif Image" style={imageStyle} />
      {/* <div style={searchBoxStyle}>
        <div style={searchButtonStyle}>
          <img
            src={currentLocationIcon}
            alt="Current Location"
            style={iconStyle}
          />
          <span style={labelTextStyle}>From</span>
        </div>
        <input
          type="text"
          placeholder="Search..."
          style={{ border: "none", outline: "none", flex: 1 }}
          defaultValue="destination"
        />
        <div style={searchButtonStyle}>
          <img src={searchIcon} alt="Search" style={iconStyle} />
          <span style={labelTextStyle}>To</span>
        </div> */}

      {/* <div style={searchBoxStyle}>
          <input type="text" placeholder="To" style={SearchStyle} />
          <img src={searchIcon} alt="Search" style={iconStyle} />
        </div> */}

      {/* <div style={searchBoxStyle}>
          <input type="text" placeholder="From" style={SearchStyle} />
          <img src={searchIcon} alt="Search" style={iconStyle} />
        </div>
        <div style={searchBoxStyle}>
          <input type="text" placeholder="To" style={SearchStyle} />
          <img src={searchIcon} alt="Search" style={iconStyle} />
        </div> */}

      {/* </div> */}
      <div style={searchBoxStyle}>
        <input type="text" placeholder="From" style={SearchStyle} />
        <img src={searchIcon} alt="Search" style={iconStyle} />
      </div>
      <div style={searchBoxStyle}>
        <input type="text" placeholder="To" style={SearchStyle} />
        <img src={searchIcon} alt="Search" style={iconStyle} />
      </div>
      <MapsComponent />
    </div>
  );
}
